import axios, { AxiosResponse } from 'axios';
import { CreateSupportQuestion, SupportQuestion } from '../models/supportQuestion'
import apiClient from './api';

const supportQuestionService = {
  createSupportQuestion: (
    supportQuestion: CreateSupportQuestion
  ): Promise<AxiosResponse<SupportQuestion>> => {
    return apiClient.post(`/supportQuestion`, supportQuestion);
  },

  getSupportQuestions: (): Promise<AxiosResponse<SupportQuestion[]>> => {
    return apiClient.get(`/supportQuestion`);
  },

  updateSupportQuestion: (
    id: number,
    supportQuestion: CreateSupportQuestion
  ): Promise<AxiosResponse<SupportQuestion>> => {
    return apiClient.put(`/supportQuestion/${id}`, supportQuestion);
  },

  deleteSupportQuestion: (id: number): Promise<AxiosResponse<void>> => {
    return apiClient.delete(`/supportQuestion/${id}`);
  },
};

export default supportQuestionService;
